import { CheckCircleOutlined, ErrorOutlineOutlined } from "@mui/icons-material";
import { Box } from "@mui/material";

type StatusCheckmarkProps = {
    checked: boolean;
};

export function StatusCheckmark({ checked }: StatusCheckmarkProps) {
    return (
        <Box
            component={checked ? CheckCircleOutlined : ErrorOutlineOutlined}
            sx={theme => ({
                padding: 0.2,
                borderRadius: "100%",
                backgroundColor: checked ? theme.palette.primary.main : theme.palette.error.main,
                color: "white",
            })}
        />
    );
}
